import { TemplateRef } from '@angular/core';
import { ColumnDefinition } from '@app/shared/models';
import { TableFilterTypes } from '@app/components/table-filter/enums/table-filter.enum';
import { TableFilterModel } from '@app/components/table-filter/models/table-filter.model';

export const tableFiltersOptions: TableFilterModel[] = [
  {
    name: 'Status',
    type: TableFilterTypes.MultiCheckbox,
    def: 'statuses',
    options: []
  },
  {
    name: 'Pr Type',
    type: TableFilterTypes.MultiCheckbox,
    def: 'types',
    options: []
  },
  {
    name: 'Currency',
    type: TableFilterTypes.MultiCheckbox,
    def: 'currencies',
    options: []
  },
  {
    name: 'Author',
    type: TableFilterTypes.MultiCheckbox,
    def: 'authors',
    options: []
  }
];

export const PR_LIST_COLUMNS = (
  dateCellTemplate: TemplateRef<unknown>,
  nameCellTemplate: TemplateRef<unknown>,
  authorTemplate: TemplateRef<unknown>,
  reqStatusTemplate: TemplateRef<unknown>,
  totalCellTemplate: TemplateRef<unknown>
): ColumnDefinition[] => [
  {
    def: 'number',
    header: '№',
    visible: true,
    sortable: true
  },
  {
    def: 'documentNumber',
    header: 'DOCUMENT NUMBER',
    visible: true,
    sortable: true
  },
  {
    def: 'name',
    header: 'PR NAME',
    cell: nameCellTemplate,
    visible: true,
    sortable: true,
    isClickable: true
  },
  {
    def: 'authorName',
    header: 'Author',
    cell: authorTemplate,
    visible: true,
    sortable: true
  },
  {
    def: 'type',
    header: 'PR_TYPE',
    visible: true,
    sortable: true
  },
  {
    def: 'currentStageName',
    header: 'STAGE',
    visible: true,
    sortable: true
  },
  {
    def: 'status',
    header: 'STATUS',
    cell: reqStatusTemplate,
    visible: true,
    sortable: true
  },
  {
    def: 'currency',
    header: 'CURRENCY',
    visible: true,
    sortable: true
  },
  {
    def: 'dateCreated',
    header: 'DATE',
    cell: dateCellTemplate,
    visible: true,
    sortable: true
  },
  {
    def: 'itemsQuantity',
    header: 'ITEMS',
    visible: true,
    sortable: true
  },
  {
    def: 'total',
    header: 'TOTAL',
    cell: totalCellTemplate,
    visible: true,
    sortable: true
  }
];
